<div class="inner">
  @if (icon) {
    <mat-icon aria-hidden="false" aria-label="filter icon" class="icon"
    [ngClass]="{'remove' : icon === 'remove_circle_outline'}">{{icon}}</mat-icon>
  }
  @if (count) {
    <span class="count">{{count}}</span>
  }
  @if (text) {
    <span>{{text | translate}}</span>
  }
</div>
